import React from 'react';
import { NumericFormat } from 'react-number-format';

const NumericFormatPhone = React.forwardRef(function NumericFormatPhone(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value, // El valor sin formato
                    },
                });
            }}
            format="#### ####"   // Formato del teléfono con espacio
            allowEmptyFormatting
            mask="_"             // Para mostrar guiones bajos donde no hay valores
        />
    );
});

export default NumericFormatPhone;
